import { render } from "./FavoriteDialog.vue?vue&type=template&id=ba4e6d8c&scoped=true&ts=true"
import script from "./FavoriteDialog.vue?vue&type=script&lang=ts"
export * from "./FavoriteDialog.vue?vue&type=script&lang=ts"

import "./FavoriteDialog.vue?vue&type=style&index=0&id=ba4e6d8c&scoped=true&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba4e6d8c"]])

export default __exports__